import React from "react";
import SupportCopy from "../../../shared/components/SponsorV2/SupportCopy/SupportCopy";
import MatchPromo from "../../../shared/components/SponsorV2/MatchPromo/MatchPromo";
import { useMatchData } from "../../../mls-match-list/utils";
import SupportCopyCompact from "../../../shared/components/SponsorV2/SupportCopyCompact/SupportCopyCompact";
import { StyledStyledFeaturedMatchPromo } from "./StyledFeaturedMatchPromo";

function FeaturedMatchPromo({ compactVersion }) {
  const { promoInfo } = useMatchData();
  const { matchPromo, promotionalSponsor, sponsorImage } = promoInfo || {};
  const { displayText } = promotionalSponsor || {};
  const { assetUrl } = sponsorImage || {};

  if (!assetUrl && !displayText && !matchPromo) {
    return null;
  }

  return (
    <StyledStyledFeaturedMatchPromo>
      {compactVersion ? (
        <SupportCopyCompact displayText={displayText} assetUrl={assetUrl} />
      ) : displayText ? (
        <SupportCopy displayText={displayText} />
      ) : null}
      {matchPromo && !compactVersion && (
        <MatchPromo
          headline={matchPromo.headline}
          description={matchPromo.description}
          callToAction1={matchPromo.callToAction1}
        />
      )}
    </StyledStyledFeaturedMatchPromo>
  );
}

export default FeaturedMatchPromo;
